import React from 'react';
import { Offer, ProductVariant } from '../../types';
import { MoneyFormat, OfferPrice, PriceBeforeDiscount } from '../elements';
import { getDiscountedPrice } from '../../dissolve/helpers';

interface Props {
  offer: Partial<Offer>;
  variant: Partial<ProductVariant>;
  quantity?: number;
}

const ProductOfferPricing = ({ offer, variant }: Props) => {
  const { apply_discount } = offer;
  const totalPrice = getDiscountedPrice(offer, variant, 1);

  let priceBeforeDiscount = null;
  if (apply_discount) {
    priceBeforeDiscount = <MoneyFormat amount={Number(variant.price) / 100} />;
  } else if (
    variant.compare_at_price &&
    Number(variant.compare_at_price) > Number(variant.price)
  ) {
    priceBeforeDiscount = (
      <MoneyFormat amount={Number(variant.compare_at_price) / 100} />
    );
  }

  return (
    <div className="Offer-Prices flex">
      <OfferPrice>
        <MoneyFormat amount={totalPrice} />
      </OfferPrice>
      {priceBeforeDiscount && (
        <PriceBeforeDiscount>{priceBeforeDiscount}</PriceBeforeDiscount>
      )}
    </div>
  );
};

export default ProductOfferPricing;
